import react, { useEffect, useContext } from 'react';
import h from '../../../helpers/common';
import { Carousel2 } from '@intigral/ui';
import { Poster } from '@intigral/shared';
import { Text } from '@intigral/shared/components/Text';
import i18n, { __ } from '../../../translations';
import Loader from '../../Loader';
import { MixpanelContext } from '../../../contexts/MixpanelContext';
import { EVENT } from '../../../contexts/MixpanelConstants';

type IMixpanelContext = {
    track?: (name: string, value: any) => void;
};

const OptionalConsent = ({ data, question }) => {
    const language = h.getLang();
    const { track } = useContext(MixpanelContext) as IMixpanelContext;

    useEffect(() => {
        track(EVENT.CONSENT.CONSENT_MARKETING_VIEW, {});
    }, []);

    return (
        <>
            <div className="container full-width">
                <div className="section-head">
                    <Text
                        as="h2"
                        variant="h2"
                        alignment="start"
                        margin={{ default: '2x', md: '3x' }}
                        // size={{ default: '18', md: '28' }}
                        data-test-id="consent-management-optional-consent-title"
                    >
                        {__(`consent_${question?.id}_optional_screen_carousel_title`)}
                    </Text>
                    {i18n.exists(`consent_${question?.id}_optional_screen_carousel_description`) && (
                        <Text as="p" alignment="start" margin={{ default: '2x', md: '3x' }}>
                            {__(`consent_${question?.id}_optional_screen_carousel_description`)}
                        </Text>
                    )}
                </div>

                {/* {data === null && <Loader componentName="VodCarousel" />} */}
                {data === null && (
                    <Carousel2 isLoading>
                        <Poster isLoading />
                    </Carousel2>
                )}
                {data && data.length > 0 && (
                    <Carousel2
                        data-test-id="consent-management-optional-consent-carousel"
                        swiperSettings={{
                            autoplay: false,
                            loop: false,
                            dir: language == 'ar' ? 'rtl' : 'ltr',
                        }}
                        dir={language == 'ar' ? 'rtl' : 'ltr'}
                    >
                        {data.map((el) => (
                            <Poster key={el.GUID} picture={el['VOD Thumbnail']} />
                        ))}
                    </Carousel2>
                )}
                {data && data.length === 0 && <h2>{__(`consent_${question?.id}_no_data_found`)}</h2>}
            </div>
        </>
    );
};

export default OptionalConsent;
